import React from 'react';
import s from './Ribbon.scss';
import {RibbonPlacementId, RibbonType} from '../../../../types/galleryTypes';
import classNames from 'classnames';
import {withTranslations} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';

export enum DataHook {
  Ribbon = 'product-item-ribbon',
}

export interface IRibbonProps {
  ribbon: string;
  placement: RibbonPlacementId;
  type: RibbonType;
  shouldShowMobile: boolean;
  isCategoryPage: boolean;
}

class RibbonComp extends React.Component<IRibbonProps> {
  public render() {
    const {ribbon, placement, type, shouldShowMobile, isCategoryPage} = this.props;
    return (
      <span
        className={classNames(
          s.ribbon,
          {[s.categoryPage]: isCategoryPage && placement !== RibbonPlacementId.ProductInfo},
          {[s.onImage]: placement === RibbonPlacementId.OnImage},
          {[s.productInfo]: placement === RibbonPlacementId.ProductInfo},
          {[s.rectangle]: type === RibbonType.RECTANGLE},
          {[s.mobile]: shouldShowMobile}
        )}
        data-hook={DataHook.Ribbon}>
        {ribbon}
      </span>
    );
  }
}

export const ProductRibbon = withTranslations()(RibbonComp);
